import { render, staticRenderFns } from "./checkout-pages.vue?vue&type=template&id=717fac5e&"
import script from "./checkout-pages.vue?vue&type=script&lang=js&"
export * from "./checkout-pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports